const isDark = localStorage.getItem('theme') === 'dark';
export const Theme = {
  fontFamily: `'Source Sans Pro', sans-serif`,

  accentColor: '#ff7e28',

  inputBorderColor: '#d6e8f6',

  darkColor: '#014b84',
  darkerColor: '#014171',

  lightColor: '#ecf6fe',

  ligherColor: '#f1f7fc',
  lighterBorderColor: '#d6e8f6',

  textDarkColor: '#20455e',
  textPrimarycolor: '#004c85',

  linkColor: '#2873ac',

  dangerColor: '#dc3545',


  modalBackgroundColor: isDark ? '#111' : '#f8f8fb',
  modalTextColor: isDark ? '#FFF' : '#495057',
  privateComment: isDark ? '#fffee820' : '#fffee8',

  isDark: isDark,
};
